import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { withSnackbar } from 'notistack';
import React, { useState } from 'react';
import { VALIDATE_YOUTUBE } from '../../../helpers/graphql/video';
import graphQLClient from '../../../helpers/graphQLClient';
import DashboardCard from '../DashboardCard';

const YoutubeDashboard = props => {
  const [video, setVideo] = useState(undefined);

  const handleVideoChange = amount => {
    setVideo(amount.target.value);
  };

  const newNotification = notification => {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      props.enqueueSnackbar(notification.message, { variant });
    }
  };

  const validateVideo = () => {
    let videoId;
    try {
      // eslint-disable-next-line prefer-destructuring
      videoId = video.split('v=')[1].split('&')[0];
    } catch {
      const ytMatch = video.match(/youtu\.be\/(.*)/);
      // eslint-disable-next-line prefer-destructuring
      if (ytMatch && ytMatch.length > 1) videoId = ytMatch[1];
      else {
        newNotification({
          success: false,
          message: 'Invalid link - use a youtube.com link',
        });
        return;
      }
    }
    graphQLClient(VALIDATE_YOUTUBE, { videoId }).then(({ validateYoutube }) => {
      if (validateYoutube.success) {
        window.open(
          `/dashboard/publish?youtubeId=${videoId}`,
          '_self',
          undefined,
          true,
        );
      } else {
        newNotification({
          success: false,
          message:
            'Video does not exist or does not belong to your linked Youtube account',
        });
      }
    });
  };

  return (
    <>
      <div className="container d-flex justify-content-center mt-5 mb-5">
        <div style={{ maxWidth: '600px' }}>
          <DashboardCard
            titleSize="h6"
            title="New video post"
            content={
              <>
                <FormLabel component="legend" className="mb-3">
                  To create a new video post, enter the link to your YouTube
                  video here.
                </FormLabel>
                <TextField
                  fullWidth
                  value={video}
                  onChange={handleVideoChange}
                  label="YouTube link"
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Button
                          className="m-1"
                          onClick={validateVideo}
                          variant="contained"
                          color="primary"
                        >
                          Create Post
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </>
            }
          />
        </div>
      </div>
    </>
  );
};

export default withSnackbar(YoutubeDashboard);
